<template>
  <div class="exam_page">
    <span class="exam_page_span"></span>
    <div class="exam_main" ref="middle_page">
      <div class="examPage">
        <div class="exam_begins_box">
          <div class="el-divider el-divider--horizontal"></div>

          <el-row>
            <el-col
              :span="10"
              style="padding-left: 20px;font-size: 18px;text-align: left;color: #29aa82;min-width: 260px"
            >{{ searchResultList.courseName }}</el-col>
          </el-row>
          <div class="el-divider el-divider--horizontal"></div>
          <el-row v-if="lang == '1'">
            <el-col :span="20" :offset="3">
              <ve-histogram :data="chartData1" :settings="chartSettings" :series="series"></ve-histogram>
            </el-col>
            <el-col :span="24">
              <ve-pie :data="chartData"></ve-pie>
            </el-col>
          </el-row>
          <el-row v-if="lang == '3'">
            <el-col :span="20" :offset="3">
              <div style="display: inline-flex">
                <div style="padding-left: 20px;text-align: left;">{{$t('new.title24')}}：</div>
                <div style="text-align: left;">{{fullMarks}}</div>
              </div>
              <div style="display: inline-flex">
                <div
                  style="padding-left: 20px;text-align: left;"
                >{{$t('scoreStatistics.passPercent')}}：</div>
                <div style="text-align: left;">{{passMarks }}</div>
              </div>
              <ve-histogram :data="chartData3" :settings="chartSettings" :series="series"></ve-histogram>
            </el-col>
            <el-col :span="24">
              <ve-pie :data="chartDataC"></ve-pie>
            </el-col>
          </el-row>
          <el-row v-if="lang == '2'">
            <el-col :span="8" :offset="3">
              <div style="display: inline-flex">
                <div style="padding-left: 20px;text-align: left;">{{$t('new.title24')}}：</div>
                <div style="text-align: left;">{{fullMarks}}</div>
              </div>
              <div style="display: inline-flex">
                <div
                  style="padding-left: 20px;text-align: left;"
                >{{$t('scoreStatistics.passPercent')}}：</div>
                <div style="text-align: left;">{{passMarks }}</div>
              </div>
              <ve-histogram :data="chartData2" :settings="chartSettings" :series="series"></ve-histogram>
            </el-col>
            <el-col :span="24">
              <ve-pie :data="chartDataB"></ve-pie>
            </el-col>
          </el-row>
          <el-row v-if="lang == '4'">
            <el-col :span="20" :offset="3">
              <div style="display: inline-flex">
                <div style="padding-left: 20px;text-align: left;">{{$t('new.title24')}}：</div>
                <div style="text-align: left;">{{fullMarks}}</div>
              </div>
              <div style="display: inline-flex">
                <div
                  style="padding-left: 20px;text-align: left;"
                >{{$t('scoreStatistics.passPercent')}}：</div>
                <div style="text-align: left;">{{passMarks }}</div>
              </div>
              <ve-histogram :data="chartData4" :settings="chartSettings" :series="series"></ve-histogram>
            </el-col>
            <el-col :span="24">
              <ve-pie :data="chartDataD"></ve-pie>
            </el-col>
          </el-row>
        </div>
        <div class="mind_map" v-if="initMindMap">
          <js-mind :values="mind" :options="options" ref="jsMind" height="800px"></js-mind>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import jm from "vue-jsmind";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.use(jm);
Vue.prototype.$lang = lang;

export default {
  name: "course_score_statistics",

  data() {
    return {
      fullMarks: 0,
      passMarks: 0,
      initMindMap: false,
      series: [],
      chartSettings: {},
      lang: null,
      xValueList: [],
      searchResultList: [],
      courseId: "",
      courseName: "",
      num: 0,
      beginDate: "",
      validity: "",
      chartData: {
        columns: ["分值范围", "人数"],
        rows: [
          { 分值范围: "合格", 人数: 2 },
          { 分值范围: "不合格", 人数: 6 },
        ],
      },
      chartDataC: {
        columns: ["点数区間", "人数"],
        rows: [
          { 点数区間: "合格", 人数: 2 },
          { 点数区間: "不合格", 人数: 6 },
        ],
      },
      chartDataB: {
        columns: ["点数区間", "人数"],
        rows: [
          { 点数区間: "Pass", 人数: 2 },
          { 点数区間: "failure", 人数: 6 },
        ],
      },
      chartDataD: {
        columns: ["点数区間", "人数"],
        rows: [
          { 点数区間: "Đỗ", 人数: 2 },
          { 点数区間: "Không đỗ", 人数: 6 },
        ],
      },
      chartData1: {
        //columns: ['分数', '成绩'],
        rows: [
          { 分数: "我的成绩", 成绩: "" },
          { 分数: "平均成绩", 成绩: "" },
          { 分数: "最高分", 成绩: "" },
          { 分数: "最低分", 成绩: "" },
        ],
      },
      chartData3: {
        //columns: ['分数', '成绩'],
        rows: [
          { 点数: "得点", 成績: "" },
          { 点数: "平均点", 成績: "" },
          { 点数: "最高点", 成績: "" },
          { 点数: "最低点", 成績: "" },
        ],
      },
      chartData2: {
        //columns: ['分数', '成绩'],
        rows: [
          { 点数: "score", 成績: "" },
          { 点数: "Average score", 成績: "" },
          { 点数: "Highest score", 成績: "" },
          { 点数: "Lowest point", 成績: "" },
        ],
      },
      chartData4: {
        //columns: ['分数', '成绩'],
        rows: [
          { 点数: "Số điểm đạt được", 成績: "" },
          { 点数: "Điểm trung bình", 成績: "" },
          { 点数: "Điểm cao nhất", 成績: "" },
          { 点数: "Điểm thấp nhất", 成績: "" },
        ],
      },
      mind: {
        meta: {
          name: "example",
          author: "hizzgdev@163.com",
          version: "0.2",
        },
        format: "node_array",
        data: [
          { id: "rootTag", isroot: true, topic: this.$route.query.courseName },
        ],
      },
      options: {
        container: "jsmind_container", // [必选] 容器的ID
        editable: false, // [可选] 是否启用编辑
        theme: "warning", // [可选] 主题
      },
      secondChapterList: [],
    };
  },
  mounted() {
    this.lang = this.$lang();
    //获取设备屏幕的高度
    const h = document.body.clientHeight - 50;
    // this.$refs.middle_page.style.minHeight = h + "px";

    const that = this;
    //接收参数
    that.num = that.$route.query.num;
    that.courseId = that.$route.query.courseId;
    that.courseName = that.$route.query.courseName;
    //登录成功
    that.userId = window.sessionStorage.getItem("id");
    that.userId = that.$route.query.userId;
    that.role = window.sessionStorage.getItem("role");
    //获取考试历史信息
    that.$api
      .post("/studyCourseQuestion/getPastExamInfo", {
        courseId: that.courseId,
      })
      .then((response) => {
        that.restCount = response.data.restCount;
        that.maxScore =
          response.data.maxScore == null ? "--" : response.data.maxScore;
        that.recentScore =
          response.data.recentScore == null ? "--" : response.data.recentScore;
        that.fullMarks = response.data.fullMarks;
        that.passMarks = response.data.passMarks;
      })
      .then(() => {
        that.$api
          .post("/home/getsingleCourseScoreStatistics", {
            courseId: that.$route.query.courseId,
            languageType: that.$lang(),
          })
          .then((response) => {
            that.searchResultList = response.data[0];
            that.xValueList[0] = that.searchResultList.userScore;
            that.xValueList[1] = that.searchResultList.avgScore;
            that.xValueList[2] = that.searchResultList.maxScore;
            that.xValueList[3] = that.searchResultList.minScore;
            that.chartData.rows[0].人数 = that.searchResultList.passNum;
            that.chartData.rows[1].人数 = that.searchResultList.noPassNum;
            that.chartDataC.rows[0].人数 = that.searchResultList.passNum;
            that.chartDataC.rows[1].人数 = that.searchResultList.noPassNum;
            that.chartDataB.rows[0].人数 = that.searchResultList.passNum;
            that.chartDataB.rows[1].人数 = that.searchResultList.noPassNum;
            that.chartDataD.rows[0].人数 = that.searchResultList.passNum;
            that.chartDataD.rows[1].人数 = that.searchResultList.noPassNum;
            that.drawLine();
          });
      });
    //取得课程目录
    that.$api
      .post("/courseStudy/getCourseSubOutlineListByTopOutline", {
        courseId: that.$route.query.courseId,
        courseName: that.$route.query.courseName,
      })
      .then((response) => {
        that.secondChapterList = response.data;
        // console.log(response.data);
        //遍历课程目录 编辑成思维导图的数据格式并push
        for (let i = 0; i < response.data.length; i++) {
          //一级目录
          if (1 == response.data[i].level) {
            that.mind.data.push({
              id: response.data[i].id,
              parentid: "rootTag",
              topic: response.data[i].chapterName,
            });
            //有得分率则显示
            if (
              1 == response.data[i].isEnd &&
              response.data[i].scoringRate != null
            ) {
              //得分率大于等于60%显示为绿色
              if (
                parseFloat(response.data[i].scoringRate) >= parseFloat("60%")
              ) {
                that.mind.data.push({
                  id: "scoringRate" + i,
                  parentid: response.data[i].id,
                  topic: response.data[i].scoringRate,
                  "background-color": "#99cc32",
                  "foreground-color": "#fefefe",
                });
              } else {
                //得分率小于60%显示为红色
                that.mind.data.push({
                  id: "scoringRate" + i,
                  parentid: response.data[i].id,
                  topic: response.data[i].scoringRate,
                  "background-color": "#ee0000",
                  "foreground-color": "#fefefe",
                });
              }
            }
          }
          //二到五级目录
          if (
            2 == response.data[i].level ||
            3 == response.data[i].level ||
            4 == response.data[i].level ||
            5 == response.data[i].level
          ) {
            that.mind.data.push({
              id: response.data[i].id,
              parentid: response.data[i].parentId,
              topic: response.data[i].chapterName,
            });
            //判断是否为最后的章节，是否有得分率
            if (
              1 == response.data[i].isEnd &&
              response.data[i].scoringRate != null
            ) {
              //得分率大于等于60%为绿色
              if (
                parseFloat(response.data[i].scoringRate) >= parseFloat("60%")
              ) {
                that.mind.data.push({
                  id: "scoringRate" + i,
                  parentid: response.data[i].id,
                  topic: response.data[i].scoringRate,
                  "background-color": "#99cc32",
                  "foreground-color": "#fefefe",
                });
              } else {
                //得分率小于60%背景色为红色
                that.mind.data.push({
                  id: "scoringRate" + i,
                  parentid: response.data[i].id,
                  topic: response.data[i].scoringRate,
                  "background-color": "#ee0000",
                  "foreground-color": "#fefefe",
                });
              }
            }
          }
        }
        //脑图初始化
        that.initMindMap = true;
      });
  },
  methods: {
    drawLine: function () {
      if (this.$lang() == "1") {
        (this.chartSettings = {
          metrics: ["成绩"],
          dimension: ["分数"],
        }),
          (this.series = [
            {
              name: "分数",
              type: "bar",
              barWidth: "50%", //这里是改变柱子的宽度
              data: this.xValueList,
              //data2:this.xValueList2,
              itemStyle: {
                //通常情况下：
                normal: {
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function (params) {
                    var colorList = [
                      "#65d186",
                      "#f67287",
                      "#f29e3c",
                      "#c05bdd",
                    ]; //每根柱子的颜色
                    return colorList[params.dataIndex];
                  },
                },
              },
            },
          ]);
      }
      if (this.$lang() == "3") {
        (this.chartSettings = {
          metrics: ["成績"],
          dimension: ["点数"],
        }),
          (this.series = [
            {
              name: "点数",
              type: "bar",
              barWidth: "50%", //这里是改变柱子的宽度
              data: this.xValueList,
              //data2:this.xValueList2,
              itemStyle: {
                //通常情况下：
                normal: {
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function (params) {
                    var colorList = [
                      "#65d186",
                      "#f67287",
                      "#f29e3c",
                      "#c05bdd",
                    ]; //每根柱子的颜色
                    return colorList[params.dataIndex];
                  },
                },
              },
            },
          ]);
      }
      if (this.$lang() == "2") {
        (this.chartSettings = {
          metrics: ["成績"],
          dimension: ["点数"],
        }),
          (this.series = [
            {
              name: "point",
              type: "bar",
              barWidth: "50%", //这里是改变柱子的宽度
              data: this.xValueList,
              //data2:this.xValueList2,
              itemStyle: {
                //通常情况下：
                normal: {
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function (params) {
                    var colorList = [
                      "#65d186",
                      "#f67287",
                      "#f29e3c",
                      "#c05bdd",
                    ]; //每根柱子的颜色
                    return colorList[params.dataIndex];
                  },
                },
              },
            },
          ]);
      }
      if (this.$lang() == "4") {
        (this.chartSettings = {
          metrics: ["成績"],
          dimension: ["点数"],
        }),
          (this.series = [
            {
              name: "Điểm thi",
              type: "bar",
              barWidth: "50%", //这里是改变柱子的宽度
              data: this.xValueList,
              //data2:this.xValueList2,
              itemStyle: {
                //通常情况下：
                normal: {
                  //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                  color: function (params) {
                    var colorList = [
                      "#65d186",
                      "#f67287",
                      "#f29e3c",
                      "#c05bdd",
                    ]; //每根柱子的颜色
                    return colorList[params.dataIndex];
                  },
                },
              },
            },
          ]);
      }
    },
    goto_lesson: function () {
      if (this.num == 1) {
        this.$router.push({
          path: "/home/courseScoreStatistics",
          query: {},
        });
      } else {
        let outlineInfo = {
          courseId: this.$route.query.courseId,
          courseName: this.$route.query.courseName,
        };
        this.$router.push({
          path: "/home/curriculum",
          query: {
            outlineInfo: JSON.stringify(outlineInfo),
          },
        });
      }
    },
    GotestPage: function () {
      this.$router.push({
        path: "/home/testPage",
        query: {
          courseId: this.courseId,
          courseName: this.$route.query.courseName,
        },
      });
    },
  },
};
</script>

<style scoped="scoped">
.page-bk-col {
  background-color: #ffffff;
}
.form-item {
  margin-left: 50px;
}
.font_col {
  color: #ffffff;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}
.exam_page {
  width: 100%;
  background-image: url(../../../static/images/bg/personset_bg.jpg);
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  display: flex;
  position: relative;
}

.exam_main {
  background-color: rgb(65, 65, 65, 0.5);
  width: 100%;
  height: 100%;
  /*min-height: 100%;*/
  /* padding-bottom: 50px; */
  min-height: calc(100vh - 50px);
}

.examPage {
  /*min-width: 1800px;*/
  /* width: 80%; */
  margin: 0 auto;
}

.examCenter_img {
  margin-top: 40px;
  width: 40%;
  margin-left: calc(20% - 30px);
  position: relative;
}

.examCenter_img img {
  height: 120px;
}

.examCenter_img p:first-child {
  font-size: 40px;
  color: #fafafa;
  font-family: marzo-w00-regular, fantasy;
  font-weight: 400;
}

.examCenter_img p:first-child span {
  font-size: 40px;
  color: #ff5252;
  font-family: braggadocio-w01, fantasy;
  font-weight: 400;
}

.examCenter_img p:nth-child(2) {
  font-size: 45px;
  color: #e8e6e6;
  font-family: roboto-thin, roboto, sans-serif;
  font-weight: 400;
}

.exam_begins_box {
  /*min-width: 700px;*/
  width: 100%;
  /* padding: 30px; */
  /* border-radius: 15px; */
  /* margin: 80px auto; */
  background-color: #ecf5ff;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}
.mind_map {
  /*min-width: 700px;*/
  /* width: 90%; */
  /* padding: 30px; */
  /* border-radius: 15px; */
  /* margin: 10px auto; */
  background-color: #ecf5ff;
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}
.course_box {
  /*min-width: 1250px;*/
  width: 100%;
  /*   padding: 30px;*/
  /* border-radius: 15px; */
  /* : 10px auto; */
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
  position: relative;
}

.exam_page_span {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.examination_notes {
  height: 20px;
  font-size: 20px;
  color: black;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_box .exam_begins_rule {
  position: relative;
  display: -webkit-flex;
  /* margin-top: 20px; */
  /* padding-top: 20px; */
  /*border-top: 1px #414141 solid;*/
}

.exam_begins_box .el-col-offset-3 {
  margin-left: 1%;
}

.exam_begins_rule .exam_begins_rule_title {
  width: auto;
  height: 20px;
  margin-right: 10px;
  font-size: 14px;
  color: #e8e6e6;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_begins_rule .exam_begins_rule_content {
  width: 520px;
  min-height: 20px;
  position: relative;
  display: block;
}

.exam_begins_rule .exam_begins_rule_content p {
  min-height: 20px;
  line-height: 20px;
  display: flex;
  font-size: 14px;
  color: #e8e6e6;
  text-align: left;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_notes {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #e8e6e6;
  text-align: center;
  font-family: source-han-sans-simplified-c, sans-serif;
  font-weight: 200;
  font-style: normal;
}

.exam_notes:first-child {
  margin-top: 40px;
}

.exam_btn {
  margin: -28px 0;
  margin-top: 3px;
  display: block;
  /*text-align: left;*/
  /*font-size: 16px;*/
  /*color: #323232;*/
  background-color: unset;
  padding: 6px 17px 6px 17px;
  /*border: 1px solid #323232;*/
  border-radius: 20px;
  /*font-family: source-han-sans-simplified-c, sans-serif;*/
  /*font-weight: 200;*/
  /*font-style: normal;*/
  /*transition:0.5s ease;*/
}

.exam_btn:hover {
  color: #000;
  background-color: #fff;
  transition: 0.1s ease;
}
.item {
  margin-top: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  /* margin: 24px 0; */
}
.el-divider {
  background-color: #dcdfe6;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/courseScoreStatistics/mobileScoreStatistics.vue